export const BASE_URL = 'https://api.37nationalgamesgoa.in/api/' // * Local BASE URL

// * Vite CONFIG
export const SERVER_URL = 'https://api.37nationalgamesgoa.in/' // * Local Server URL


// * AXIOS
//export const BASE_URL = 'http://13.200.216.166:3007/api/' // * Local BASE URL

// * Vite CONFIG
//export const SERVER_URL = 'http://13.200.216.166:3007/' // * Local Server URL
